import type { AppLocale } from "@/lib/i18n/locales";

const FALLBACK_LOCALE: AppLocale = "zh-CN";

const archiveBaseMap: Record<AppLocale, string> = {
  "zh-CN": "批量任务结果",
  en: "batch-task-results",
  ru: "результаты-пакетных-задач",
  ko: "배치작업결과",
  ja: "バッチタスク結果",
  es: "resultados-tareas-por-lotes",
  de: "batch-aufgabenergebnisse",
};

const resultCsvBaseMap: Record<AppLocale, string> = {
  "zh-CN": "批量任务ID",
  en: "batch-task-ids",
  ru: "id-пакетных-задач",
  ko: "배치작업ID",
  ja: "バッチタスクID",
  es: "ids-tareas-por-lotes",
  de: "batch-aufgaben-ids",
};

const templateBaseMap: Record<AppLocale, string> = {
  "zh-CN": "批量任务模板",
  en: "batch-task-template",
  ru: "шаблон-пакетных-задач",
  ko: "배치작업-템플릿",
  ja: "バッチタスクテンプレート",
  es: "plantilla-tareas-por-lotes",
  de: "batch-aufgaben-vorlage",
};

const resolveForLocale = (map: Record<AppLocale, string>, locale: AppLocale): string => {
  return map[locale] ?? map[FALLBACK_LOCALE];
};

export const getBatchArchiveFilename = (locale: AppLocale, timestamp: number = Date.now()): string => {
  const base = resolveForLocale(archiveBaseMap, locale);
  return `${base}-${timestamp}.zip`;
};

export const getBatchResultCsvFilename = (locale: AppLocale, timestamp: number = Date.now()): string => {
  const base = resolveForLocale(resultCsvBaseMap, locale);
  return `${base}-${timestamp}.csv`;
};

export const getBatchTemplateFilename = (locale: AppLocale): string => {
  const base = resolveForLocale(templateBaseMap, locale);
  return `${base}.csv`;
};
